var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"error-messages":_vm.error,"label":_vm.label,"items":_vm.optionsSexos,"filled":""},on:{"change":_vm._doEmits},model:{value:(_vm.valueSelected),callback:function ($$v) {_vm.valueSelected=$$v},expression:"valueSelected"}})}
var staticRenderFns = []

export { render, staticRenderFns }